export const FETCH_STATUS_ENUM = {
  LOADING: {
    status: 'loading',
    displayName: 'LOADING',
    color: 'blue',
  },
  SUCCESS: {
    status: 'succeeded',
    displayName: 'LOADED SUCCESSFULLY',
    color: 'green',
  },
  FAILED: {
    status: 'failed',
    displayName: 'FETCH FAILED',
    color: 'red',
  },
  KOGAN_ASYNCRESPONSEPENDING: {
    status: 'AsyncResponsePending',
    displayName: 'RESPONSE PENDING',
    color: 'orange',
    buildStatus: (url) => {
      return {
        status: 'AsyncResponsePending',
        displayName: 'RESPONSE PENDING',
        color: 'orange',
        url,
      };
    },
  },
  KOGAN_COMPLETE: {
    status: 'Complete',
    displayName: 'SAVED TO KOGAN',
    color: 'green',
  },
  KOGAN_COMPLETE_WITH_ERRORS: {
    status: 'CompleteWithErrors',
    displayName: 'SAVED WITH ERRORS',
    color: 'orange',
  },
  KOGAN_FAILED: {
    status: 'Failed',
    displayName: 'KOGAN UPDATE FAILED',
    color: 'red',
  },
  GENERIC_ERROR: { status: 'error', displayName: 'ERROR', color: 'red' },
  SAVING: { status: 'saving', displayName: 'SAVING', color: 'blue' },
};

export const OPENAI_PROMPTS = {
  PROMPT_DESCRIPTION: {
    key:'prompt.description',
    title: 'Make listing description better',
    prompt:
      'Use the provided product information to create an Amazon product listing description.'+
      ' The description should not exceed 400 words and should be SEO optimized. Make it sound enticing for prospective customers. Product information: ',
  },
  PROMPT_FEATURES: {
    key:'prompt.features',
    title: 'Generate 20 features',
    prompt: 'Use the provided product information to create SEO optimized benefits of the product.'
            +'Each feature should be in the format Feature Title - Feature Description.'
            +'The feature title should not exceed 3-4 words and should be in title-case.'
            +'The feature description should explain the benefit in simple language and not exceed 10 words.'
            +'Make sure you generate a minumum of 20 features. Product information: ',
  },
  // PROMPT_TOP3_FEATURES: {
  //   key:'prompt.top3features',
  //   title: 'Generate top 3 features',
  //   prompt: 'Use the provided product information to generate top 3 benefit focused features.'
  //   + ' The top 3 features should be the main higlights of the product.'
  //   + ' Make sure the features do not exceed 3-4 words. Product information: ',
  // },
  // PROMPT_TOP3_SPECS: {
  //   key:'prompt.top3specs',
  //   title: 'Generate top 3 specs',
  //   prompt: 'Use the provided product information to generate top 3 core technical specifications of the product. Make sure the specifications do not exceed 3-4 words. Product information: ',
  // },
};
